/* eslint-disable max-len */
import React, { Component } from 'react';
import { PulseLoader } from 'react-spinners';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input';
import InputMask from 'react-input-mask';
import { FaAngleRight } from 'react-icons/fa';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { editStore } from '../../../../queries';

import MapComponent from '../../../../components/Map/Store/Account/Shipping';

import Content from './styles';
import {
  Row,
  Label,
  SelectLabel,
  CurrencyLabel,
  Input,
  Button,
} from '../../../../assets/styles';


const deliveryTime = [
  { value: '5', label: '5 min' },
  { value: '10', label: '10 min' },
  { value: '15', label: '15 min' },
  { value: '20', label: '20 min' },
  { value: '25', label: '25 min' },
  { value: '30', label: '30 min' },
  { value: '35', label: '35 min' },
  { value: '40', label: '40 min' },
  { value: '45', label: '45 min' },
  { value: '50', label: '50 min' },
  { value: '55', label: '55 min' },
  { value: '60', label: '60 min' },
  { value: '65', label: '65 min' },
  { value: '70', label: '70 min' },
  { value: '75', label: '75 min' },
  { value: '80', label: '80 min' },
  { value: '85', label: '85 min' },
  { value: '90', label: '90 min' },
  { value: '95', label: '95 min' },
  { value: '100', label: '100 min' },
  { value: '105', label: '105 min' },
  { value: '110', label: '110 min' },
  { value: '115', label: '115 min' },
  { value: '120', label: '120 min' },
  { value: '125', label: '125 min' },
  { value: '130', label: '130 min' },
  { value: '135', label: '135 min' },
  { value: '140', label: '140 min' },
  { value: '145', label: '145 min' },
  { value: '150', label: '150 min' },
  { value: '155', label: '155 min' },
  { value: '160', label: '160 min' },
  { value: '165', label: '165 min' },
  { value: '170', label: '170 min' },
  { value: '175', label: '175 min' },
  { value: '180', label: '180 min' },
];

class Shipping extends Component {
  state = {
    orders: {
      minimum: '',
      floatValue: 0,
    },
    delivery: {
      smaller: null,
      bigger: null,
      price: 'R$ 0,00',
      floatValue: 0,
      distance: null,
    },
    coords: {
      lat: null,
      lng: null,
    },
    ordersPriceError: false,
    ordersPriceFocus: false,
    deliveryTimeSmallerError: false,
    deliveryTimeBiggerError: false,
    deliveryPriceError: false,
    deliveryPriceFocus: false,
    deliveryDistanceError: false,
    deliveryDistanceFocus: false,
  }

  componentWillMount = () => {
    this.setState({
      orders: {
        minimum: this.props.store.orders.minimum,
        floatValue: this.props.store.orders.minimum,
      },
      delivery: {
        smaller: this.props.store.delivery.time.smaller,
        bigger: this.props.store.delivery.time.bigger,
        price: this.props.store.delivery.price,
        floatValue: this.props.store.delivery.price,
        distance: this.props.store.delivery.distance,
      },
      coords: {
        lat: this.props.store.address.lat,
        lng: this.props.store.address.lng,
      },
      deliveryTimeSmallerDefault: [{ value: `${this.props.store.delivery.time.smaller}`, label: `${this.props.store.delivery.time.smaller} min` }],
      deliveryTimeBiggerDefault: [{ value: `${this.props.store.delivery.time.bigger}`, label: `${this.props.store.delivery.time.bigger} min` }],
    });
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const {
      orders,
      delivery,
      ordersPriceError,
      deliveryTimeSmallerError,
      deliveryTimeBiggerError,
      deliveryPriceError,
      deliveryDistanceError,
    } = this.state;

    if (
      !ordersPriceError
      && !deliveryTimeSmallerError
      && !deliveryTimeBiggerError
      && !deliveryPriceError
      && !deliveryDistanceError
    ) {
      this.setState({ loading: true });

      const data = {
        orders: { minimum: orders.floatValue },
        delivery: {
          time: { smaller: Number(delivery.smaller), bigger: Number(delivery.bigger) },
          price: delivery.floatValue,
          distance: Number(delivery.distance),
        },
      };

      this.props
        .editStore({
          variables: {
            storeId: this.props.store.id,
            data,
          },
        })
        .then(async () => {
          this.setState({ loading: false });

          this.props.alert.success('Informações salvas com sucesso');

          this.props.handleChangeState(data);
        });
    }
  }

  validateInputs = () => {
    const { orders, delivery } = this.state;

    this.setState({
      ordersPriceError: false,
      deliveryTimeSmallerError: false,
      deliveryTimeBiggerError: false,
      deliveryDistanceError: false,
      deliveryPriceError: false,
    });

    if (orders.floatValue > 999999.99) this.setState({ ordersPriceError: true });
    if (!delivery.smaller) this.setState({ deliveryTimeSmallerError: true });
    if (!delivery.bigger) this.setState({ deliveryTimeBiggerError: true });
    if (delivery.smaller && delivery.bigger) {
      if (Number(delivery.smaller) > Number(delivery.bigger)) {
        this.setState({ deliveryTimeSmallerError: true });
        this.setState({ deliveryTimeBiggerError: true });
      }
    }
    if (!delivery.distance || Number(delivery.distance) === 0) this.setState({ deliveryDistanceError: true });
    if (delivery.floatValue > 999.99) this.setState({ deliveryPriceError: true });
  }

  handleDeliveryChange = (field, value) => {
    this.setState(state => ({
      delivery: {
        ...state.delivery,
        [field]: value,
      },
    }));
  }

  handleOrderValueChange = (event, maskedValue, floatValue) => {
    this.setState({
      orders: {
        minimum: maskedValue,
        floatValue,
      },
    });
  }

  handleTaxValueChange = (event, maskedValue, floatValue) => {
    this.setState(state => ({
      delivery: {
        ...state.delivery,
        price: maskedValue,
        floatValue,
      },
    }));
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      loading,
      orders,
      delivery,
      deliveryTimeSmallerDefault,
      deliveryTimeBiggerDefault,
      ordersPriceError,
      ordersPriceFocus,
      deliveryTimeSmallerError,
      deliveryTimeBiggerError,
      deliveryPriceError,
      deliveryPriceFocus,
      deliveryDistanceError,
      deliveryDistanceFocus,
    } = this.state;

    return (
      <Content>
        <Row>
          <h2 style={{ marginBottom: 5 }}>Valor minímo do pedido</h2>
          <p className="subtitle">
            {'Seus clientes não poderão concluir nenhum pedido com o valor menor que o definido neste campo.'}
          </p>
          <div className="row-2">
            <Label style={{ marginBottom: 0 }}>
              <div className="row-2-2">
                <Label>
                  <p className="fieldName">Valor</p>
                  <CurrencyLabel error={ordersPriceError} onFocusInput={ordersPriceFocus}>
                    <CurrencyInput
                      size="10"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                      className="input"
                      value={orders.minimum}
                      onChangeEvent={this.handleOrderValueChange}
                      onFocus={() => this.onFocus('ordersPriceFocus')}
                      onBlur={() => this.onBlur('ordersPriceFocus')}
                    />
                  </CurrencyLabel>
                </Label>
                <Label style={{ marginBottom: 0 }} />
              </div>
            </Label>
            <Label style={{ marginBottom: 0 }} />
          </div>
          <h2 style={{ marginBottom: 5 }}>Área de entrega</h2>
          <p className="subtitle">
            {'Sua loja aparecerá apenas para clientes que estão dentro do raio de distância definido neste campo.'}
          </p>
          <div className="row-2">
            <Label style={{ marginBottom: 0 }}>
              <div className="row-2-2">
                <Label>
                  <p className="fieldName">Distância (km)</p>
                  <InputMask
                    mask="99"
                    maskChar={null}
                    value={delivery.distance}
                    onFocusInput={deliveryDistanceFocus}
                    onChange={value => this.handleDeliveryChange('distance', value.target.value)}
                    onFocus={() => this.onFocus('deliveryDistanceFocus')}
                    onBlur={() => this.onBlur('deliveryDistanceFocus')}
                  >
                    {inputProps => (
                      <Input
                        {...inputProps}
                        type="text"
                        size="10"
                        error={deliveryDistanceError}
                      />
                    )}
                  </InputMask>
                </Label>
                <Label style={{ marginBottom: 0 }} />
              </div>
            </Label>
            <Label style={{ marginBottom: 0 }} />
          </div>
          <MapComponent coords={this.state.coords} distance={delivery.distance} />
          <h2 style={{ marginTop: '45px' }}>Tempo de entrega</h2>
          <div className="row-2">
            <Label style={{ marginBottom: 0 }}>
              <div className="row-2-2">
                <Label>
                  <p className="fieldName">Minímo</p>
                  <SelectLabel error={deliveryTimeSmallerError}>
                    <Select
                      className="input"
                      classNamePrefix="input"
                      placeholder="Selecione"
                      options={deliveryTime}
                      defaultValue={deliveryTimeSmallerDefault}
                      onChange={value => this.handleDeliveryChange('smaller', value.value)}
                      isSearchable={false}
                      isClearable={false}
                    />
                  </SelectLabel>
                </Label>
                <Label>
                  <p className="fieldName">Máximo</p>
                  <SelectLabel error={deliveryTimeBiggerError}>
                    <Select
                      className="input"
                      classNamePrefix="input"
                      placeholder="Selecione"
                      options={deliveryTime}
                      defaultValue={deliveryTimeBiggerDefault}
                      onChange={value => this.handleDeliveryChange('bigger', value.value)}
                      isSearchable={false}
                      isClearable={false}
                    />
                  </SelectLabel>
                </Label>
              </div>
            </Label>
            <Label />
          </div>
          <h2>Taxa de entrega</h2>
          <div className="row-2">
            <Label style={{ marginBottom: 0 }}>
              <div className="row-2-2">
                <Label>
                  <p className="fieldName">Valor</p>
                  <CurrencyLabel error={deliveryPriceError} onFocusInput={deliveryPriceFocus}>
                    <CurrencyInput
                      size="10"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                      className="input"
                      value={delivery.price}
                      onChangeEvent={this.handleTaxValueChange}
                      onFocus={() => this.onFocus('deliveryPriceFocus')}
                      onBlur={() => this.onBlur('deliveryPriceFocus')}
                    />
                  </CurrencyLabel>
                </Label>
                <Label style={{ marginBottom: 0 }} />
              </div>
            </Label>
            <Label style={{ marginBottom: 0 }} />
          </div>
          <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
            {!loading ? (
              <span>
                {'Salvar'}
                <FaAngleRight className="fa fa-angle-right" />
              </span>
            ) : (
              <PulseLoader
                sizeUnit="px"
                size={7}
                color="#FFFFFF"
                loading={loading}
                style={{ paddingLeft: '25px' }}
              />
            )}
          </Button>
        </Row>
      </Content>
    );
  }
}

export default compose(
  withAlert(),
  graphql(editStore, { name: 'editStore' }),
)(Shipping);
